import get from 'lodash.get';

const getUserInformation = (state) => {
  const information = get(state, 'information');
  return information;
};

export default { getUserInformation };
